import { IMAGE_QUALITY, IMAGE_STORAGE } from "../env";

export const getImageUrl = url => {
    return `${IMAGE_STORAGE}${url}`;
}

export const getImageQuality = () => {
    return IMAGE_QUALITY ? `&q=${IMAGE_QUALITY}` : '';
}

export const getAvatarImageUrl = (url) => {
    const qualityParam = getImageQuality();
    return `${getImageUrl(url)}?w=200${qualityParam}`;
}

export const getHeroImageUrl = (url, keepFormat = false) => {
    if (!url) {
        return undefined;
    }

    const keepFormatParam = keepFormat ? '' : '&keepFormat=false';
    const qualityParam = getImageQuality();
    return `${getImageUrl(url)}?w=1500&h=350${keepFormatParam}${qualityParam}`;
}

export const getSmallHeroImage = (url) => {
    if (!url) {
        return undefined;
    }

    const qualityParam = getImageQuality();
    return `${getImageUrl(url)}?w=304${qualityParam}`;
}

export const getSmallImageUrl = value => {
    const qualityParam = getImageQuality();
    return value && `${getImageUrl(value)}?w=112${qualityParam}`;
}